// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nJZl","label":"styles_label__28UhF"};